import { Users } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgUserGroup = mkIcon(Users);
